//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
SPLM.GeometricUtilities.CurveLocation = class{
    constructor(type,location){
        this.type=type;this.location=location;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get Location(){if(this.location === undefined) this.location = new SPLM.Point3d(); return this.location}
    set Location(val){this.location = val}
};

SPLM.GeometricUtilities.CurveLocationType = Object.freeze({
    "Start" : "Start", "End" : "End", "Center" : "Center", "Mid" : "Mid"});

export default SPLM;